export default (Vue) => {
  Vue.mixin({
    // computed: {
    //   symbol() {
    //     return this.$route.query.symbol
    //   },
    //   market() {
    //     return this.$getMarket(this.symbol)
    //   }
    // }
  })
}
